<template>
  <div
    class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
  >
    <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
      <btn
        class="btn-success btn-md"
        :process="process"
        @click="save"
      >
        <span class="p-l-20 p-r-10">Save</span>
      </btn>
    </div>
  </div>
  <dataTable
    :name="'CustomerDedicatedProxies'"
    :columnDefs="columnDefs"
    ref="agGrid"
    :data="data"
          :addContextMenuItem="getContextMenuItems"
    @cellClicked="$refs.agGrid.changeRow('Id', {
      ...$event.data,
      isSelected:!$event.data.isSelected
    })"
          :rowClassRules="{
            // row style function
            success: (params) => {
              // var numSickDays = params.data;
              return params?.data?.isSelected;
            },
          }"
  ></dataTable>
</template>

<script>
export default {
  name: "DedicatedProxies",
  props: {
    setModel: Object,
  },
  data() {
    return {
      data: null,
      beforeSelected:null,
      process:false,
      columnDefs: [
        {
          headerName: "",
          field: "isSelected",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          width: 50,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "Id",
          field: "Id",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 60,
        },
        {
          headerName: "ProviderName",
          field: "ProviderName",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "IpAddress",
          field: "IpAddress",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Port",
          field: "Port",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Username",
          field: "Username",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "Password",
          field: "Password",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "OutputIp",
          field: "OutputIp",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 140,
        },
        {
          headerName: "IsActive",
          field: "IsActive",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "IsTrafficBillable",
          field: "IsTrafficBillable",
          enableRowGroup: true,
          floatingFilter: false,
          filter: false,
          flex: 1,
          minWidth: 140,
          cellRenderer: this.$CheckCellRenderer,
        },
      ],
    };
  },
  created() {
    this.$appAxiosAdmin
      .get(`CustomerProxies/` + this.setModel.Id)
      .then((response) => {
        this.beforeSelected=response.data.map((x) => x.ProxyId);
        this.$appAxiosAdmin.get(`DedicatedProxies`).then((proxies) => {
          this.data = proxies.data
            .map((y) => {
              return {
                ...y,
                isSelected:
                  response.data.filter((x) => x.ProxyId == y.Id).length > 0,
              };
            })
            .sort((x, y) => {
              return (x.isSelected ? -1 : 0) - (y.isSelected ? -1 : 0);
            });
        });
      });
  },
  methods: {
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Output Ip Search And Update",
          icon: '<i class="far fa-question-circle"></i>',
          action: () => {
            this.$appAxiosAdmin.get(`DedicatedProxies/ip/`+params.node.data.Id).then((response) => {
              this.$swal({
                icon: "info",
                title: "Output Ip",
                text: response.data,
                confirmButtonText: "Okey",
              });
              this.$refs.agGrid.changeRow('Id', {...params.node.data,OutputIp:response.data});
            });
          },
        },
      ];
      return result;
    },
    save(){
      let model={
        "AddedProxyIds": this.data
          .filter((x) => x.isSelected)
          .map((x) => x.Id),
        "RemovedProxyIds": [
        ]
      }
      model.RemovedProxyIds=this.beforeSelected.filter(x=>model.AddedProxyIds.indexOf(x)==-1);
      this.process=true;
    this.$appAxiosAdmin
      .post(`CustomerProxies/` + this.setModel.Id,model)
      .then(() => { 
        this.$swal({
                icon: "success",
                title: "Success",
                timer: 2000,
                confirmButtonText: "Okey",
              });
      this.process=false;
      }).catch((err) => {
        this.$isError(err);
        this.process=false;
      });
    }
  },
};
</script>

<style></style>
